import { View } from "../../../../core/view/index";
import { Template } from "../../../../core/template/index";
import { FortumApp } from "../../../fortumApp";
import { Order, OrderLike } from "../../../db/models/decontamination/order";
import { OrderItemLike, OrderItem } from "../../../db/models/decontamination/orderItem";
import MessageModal from "../../../../core/modals/message/index";


export class OrderBaseView extends View
{
    public template = Template.empty();
    public app: FortumApp;
    public data: OrderBaseViewData;

    private getOrder(uuid: string): PromiseLike<OrderLike[]>
    {
        return Order.withAll(this.app.db, this.app.db.DeconOrder.where('uuid').equals(uuid).limit(1));
    }

    private getOrderItem(id: number): PromiseLike<OrderItemLike[]>
    {
        return OrderItem.withAll(this.app.db, this.app.db.DeconOrderItem.where('id').equals(id).limit(1));
    }

    private resolveOrder(): PromiseLike<void>
    {
        let taskId = this.app.request.parameters[0];
        
        return this.getOrder(taskId).then((tasks) =>
        {
            let task = tasks[0];
            this.data.order = task;

            if (task == null)
            {
                new MessageModal({
                    title: this.ugettext('Error'),
                    message: this.pgettext('Message', 'Record with uuid {id} does not exist. Please check the QR code and/or the entered id.', {
                        id: this.app.request.parameters[0]
                    }),
                }).showIn(this.app);
                console.error('Cannot fetch the equipment info');
                location.hash = '#/';
                return null;
            }
        });
    }

    private resolveOrderItem()
    {
        let orderItemId = this.app.request.parameters[1];
        if (orderItemId == null)
        {
            return Promise.resolve();
        }

        return this.getOrderItem(parseInt(orderItemId)).then((orderItems) =>
        {
            this.data.item = orderItems[0];
        });
    }
    
    public beforeRender(): PromiseLike<void>
    {
        return super.beforeRender().then(() =>
        {
            return <PromiseLike<void>>Promise.all([
                this.resolveOrder(),
                this.resolveOrderItem(),
            ]).then(() =>
            {
                
            });
        });
    }
}


export interface OrderBaseViewData
{
    order?: OrderLike;
    item: OrderItemLike;
}